import { render, staticRenderFns } from "./VideoHistory.vue?vue&type=template&id=5999041a&scoped=true"
import script from "./VideoHistory.vue?vue&type=script&lang=ts"
export * from "./VideoHistory.vue?vue&type=script&lang=ts"
import style0 from "./VideoHistory.vue?vue&type=style&index=0&id=5999041a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5999041a",
  null
  
)

export default component.exports